import css from './Schedule.module.css';

function DateRangePicker({ displayPeriod, setDisplayPeriod }) {
  return (
    <div className={css.dateRangePicker}>
      <label>
        Start Date:
        <input
          type="date"
          value={displayPeriod.startDate.toISOString().split('T')[0]}
          onChange={(e) =>
            setDisplayPeriod((prev) => ({
              ...prev,
              startDate: new Date(e.target.value),
            }))
          }
        />
      </label>
      <label>
        End Date:
        <input
          type="date"
          value={displayPeriod.endDate.toISOString().split('T')[0]}
          onChange={(e) =>
            setDisplayPeriod((prev) => ({
              ...prev,
              endDate: new Date(e.target.value),
            }))
          }
        />
      </label>
    </div>
  );
}

export default DateRangePicker;
